import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="xdelivery-map"
export default class extends Controller {
  static targets = ['storeName', 'storeNum', 'storeAddress'];
  static values = { callbackUrl: String }

  connect() {
    window.addEventListener('message', (event) => {
      // 從 callback URL 創建 URL 物件來獲取 origin
      const url = new URL(this.callbackUrlValue);

      if (event.origin !== url.origin) {
        console.error('Unauthorized message source');
        return;
      }

      // 驗證資料完整性
      if (event.data.id && event.data.name && event.data.address) {
        // 基本資料清理
        const sanitizedId = String(event.data.id).trim();
        const sanitizedName = String(event.data.name).trim();
        const sanitizedAddress = String(event.data.address).trim();

        this.storeNumTarget.value = sanitizedId;
        this.storeNameTarget.value = sanitizedName;
        this.storeAddressTarget.value = sanitizedAddress;

        $('#storeData').text(`${sanitizedId} ${sanitizedName}(${sanitizedAddress})`);
      }
    });
  }

  submit(event) {
    event.preventDefault(); 

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://map.xdelivery.io/fami';
    form.target = '_blank';
    form.rel = 'opener';

    const callbackUrlInput = document.createElement('input');
    callbackUrlInput.type = 'hidden';
    callbackUrlInput.name = 'callback_url';
    callbackUrlInput.value = this.callbackUrlValue;

    form.appendChild(callbackUrlInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}